import { render, staticRenderFns } from "./hoteles.vue?vue&type=template&id=2016a1ad&"
import script from "./hoteles.vue?vue&type=script&lang=js&"
export * from "./hoteles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports